import { render, staticRenderFns } from "./VgtTableHeader.vue?vue&type=template&id=533e5318&scoped=true&"
import script from "./VgtTableHeader.vue?vue&type=script&lang=js&"
export * from "./VgtTableHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "533e5318",
  null
  
)

export default component.exports